import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/customer_/$customerId/contacts/_list/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
